<style src="./Record.scss" lang="scss" scoped></style>
<template lang="html">
  <section class="record">
    <content-header path="Cadastro"/>

    <ul class="card-list-container">
      <li
        class="card-list-item size-200x400"
        @click="jumpToRoute('user')"
        v-if="$store.getters['Login/HAS_PERMISSION_IN_AREA']({area: 'record-user', action: 'SHOW'})">
        <icon-menu-user />
        <h3>Usuário</h3>
      </li>
      <li
        class="card-list-item size-200x400"
        @click="jumpToRoute('client')"
        v-if="$store.getters['Login/HAS_PERMISSION_IN_AREA']({area: 'record-client', action: 'SHOW'})">
        <icon-menu-client />
        <h3>Cliente</h3>
      </li>
      <li
        class="card-list-item size-200x400"
        @click="jumpToRoute('permission')"
        v-if="$store.getters['Login/HAS_PERMISSION_IN_AREA']({area: 'permission', action: 'SHOW'})">

        <icon-menu-permission />
        <h3>Permissão</h3>
      </li>
      <li
        class="card-list-item size-200x400"
        @click="jumpToRoute('occupation')"
        v-if="$store.getters['Login/HAS_PERMISSION_IN_AREA']({area: 'occupation', action: 'SHOW'})">

        <icon-menu-occupation />
        <h3>Ocupação</h3>
      </li>
      <li
        class="card-list-item size-200x400"
        @click="jumpToRoute('cmed')"
        v-if="$store.getters['Login/HAS_PERMISSION_IN_AREA']({area: 'cmed', action: 'SHOW'})">

        <icon-menu-price-tag />
        <h3>CMED</h3>
      </li>
      <li
        class="card-list-item size-200x400"
        @click="jumpToRoute('stock')"
        v-if="$store.getters['Login/HAS_PERMISSION_IN_AREA']({area: 'stock', action: 'SHOW'})">

        <icon-menu-stock />
        <h3>Estoque</h3>
      </li>
      <li
        class="card-list-item size-200x400"
        @click="jumpToRoute('responsabilities')"
        v-if="$store.getters['Login/HAS_PERMISSION_IN_AREA']({area: 'stock', action: 'SHOW'})">

        <icon-menu-stock />
        <h3>Responsabilidades</h3>
      </li>
      <li
        class="card-list-item size-200x400"
        @click="jumpToRoute('cbpf')"
        v-if="$store.getters['Login/HAS_PERMISSION_IN_AREA']({area: 'stock', action: 'SHOW'})">

        <icon-menu-stock />
        <h3>CBPF</h3>
      </li>
      <li
        class="card-list-item size-200x400"
        @click="jumpToRoute('suppliers')"
        v-if="$store.getters['Login/HAS_PERMISSION_IN_AREA']({area: 'stock', action: 'SHOW'})">

        <icon-menu-stock />
        <h3>Fornecedores</h3>
      </li>
      <li
        class="card-list-item size-200x400"
        @click="jumpToRoute('document-type')"
        v-if="$store.getters['Login/HAS_PERMISSION_IN_AREA']({area: 'stock', action: 'SHOW'})">

        <icon-menu-stock />
        <h3>Tipo de Documento</h3>
      </li>
      <li
        class="card-list-item size-200x400"
        @click="jumpToRoute('distributors')"
        v-if="$store.getters['Login/HAS_PERMISSION_IN_AREA']({area: 'stock', action: 'SHOW'})">

        <icon-menu-stock />
        <h3>Distribuidoras</h3>
      </li>
    </ul>
  </section>
</template>

<script>
import ContentHeader from '@/components/foundation/content-header/ContentHeader'
import {IconMenuUser,
        IconMenuClient,
        IconMenuOccupation,
        IconMenuPriceTag,
        IconMenuStock,
        IconMenuPermission} from '@/components/primitives/icons'

export default {
  name: 'Record',
  components: {
    ContentHeader,
    IconMenuUser,
    IconMenuClient,
    IconMenuPermission,
    IconMenuOccupation,
    IconMenuStock,
    IconMenuPriceTag
  },
  methods: {
    jumpToRoute (pPath) {
      this.$router.push(pPath)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/record/Record.vue